import { PolicyStore } from '@Policy/store';
import { DlpExchangePolicyItem } from '@Policy/utils/types';

export const kfAdvancedOptionConfigSelector = (s: PolicyStore) => {
  const {
    config: {
      defaultValue: {
        tmKeywordfilters: { kfReplacementText: kfReplacementTextDefault },
      },
    },
  } = s;
  const { tmKeywordfilters } = s.template as DlpExchangePolicyItem;
  const config = {
    replaceText: tmKeywordfilters?.kfReplacementText || '',
    replaceTextDefault: kfReplacementTextDefault,
  };
  return config;
};
